import React from 'react';
import { View } from 'react-native';
import CountDownComp from 'react-native-countdown-component';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import LoginTestKeys from '../../../Utils/LoginTestKeys';

import styles from './CountDown.Styles';

function CountDown({
  withCountdown,
  resendCodeDisabled,
  countdownProps,
  resendCodeTimeout,
  theme,
}) {
  if (!withCountdown || !resendCodeDisabled) {
    return null;
  }
  const { separatorStyle, digitStyle, digitTxtStyle, containerStyle, bracketStyle, onFinish } =
    countdownProps || {};
  return (
    <View
      style={[styles.countDownContainer(theme), containerStyle]}
      testID={LoginTestKeys.countDownTimer}
    >
      <VFText i18nKey={'('} style={[styles.bracket(theme), bracketStyle]} />
      <CountDownComp
        until={resendCodeTimeout / 1000}
        timeToShow={['M', 'S']}
        timeLabels={{ m: '', s: '' }}
        showSeparator
        separatorStyle={[styles.separatorStyle(theme), separatorStyle]}
        digitStyle={[styles.digitStyle(theme), digitStyle]}
        digitTxtStyle={[styles.digitTxtStyle(theme), digitTxtStyle]}
        onFinish={_isFunction(onFinish) && onFinish}
      />
      <VFText i18nKey={')'} style={[styles.bracket(theme), bracketStyle]} />
    </View>
  );
}

CountDown.defaultProps = {
  theme: LightThemeColors,
};

CountDown.propTypes = {
  withCountdown: PropTypes.bool,
  resendCodeDisabled: PropTypes.bool,
  countdownProps: PropTypes.object,
  resendCodeTimeout: PropTypes.number,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(CountDown);
